import { useState } from "react";
import { ChipGroup } from "@/components/ChipGroup";
import { presetAt, toLocalInput, fmtDT } from "@/lib/constants";

const PRESETS = { "2h": "In 2 hrs", tomorrow: "Tomorrow", "3d": "3 Days", week: "Next Week", custom: "Custom" };

export const FollowUpPicker = ({ value, onChange, testPrefix = "followup" }) => {
  const [kind, setKind] = useState(null);
  const pick = (k) => {
    setKind(k);
    if (k !== "custom") onChange(presetAt(k).toISOString());
  };
  return (
    <div className="space-y-2">
      <ChipGroup options={Object.keys(PRESETS)} value={kind} onChange={pick} testPrefix={testPrefix} getLabel={(k) => PRESETS[k]} />
      {kind === "custom" && (
        <input
          type="datetime-local"
          data-testid={`${testPrefix}-custom-input`}
          className="w-full rounded-lg border border-neutral-200 bg-white px-3 py-2 text-sm text-[#1A1A1A]"
          defaultValue={toLocalInput(presetAt("tomorrow"))}
          onChange={(e) => e.target.value && onChange(new Date(e.target.value).toISOString())}
        />
      )}
      {value && <p data-testid={`${testPrefix}-selected`} className="font-mono text-xs text-[#1F9E7A]">Next action → {fmtDT(value)}</p>}
    </div>
  );
};
